import ArrowRight3SVG from "../../../../svgs/ArrowRight3SVG";
import Solution from "../../../../pngs/Solution.png";
import Solutions from "../../../../data/Solutions";
import { useState } from "react";

const Content = () => {
  const [currentTitle, setCurrentTitle] = useState(
    "💼 MetaLawyers – A True Revolution in Professional Legal Practice"
  );
  const [currentContent, setCurrentContent] = useState(`
        🔰 The First Fully Specialized, Comprehensive AI Platform for Licensed Attorneys Worldwide
        What MetaLawyers offers is not merely technology—it is the birth of a new era of intelligent, doctrinally grounded, and strategy-driven legal advocacy. This world-first platform is engineered exclusively for practicing attorneys and has been launched—proudly—for the first time in the Islamic Republic of Iran.

        No jurisdiction, no bar association, and no global legal institution has yet succeeded in building a platform with this scope, depth, and alignment with the real and evolving needs of legal practitioners.

        ✨ A Global Legal Breakthrough—Pioneered from Iran ✨
        `);

  const handleItemClick = (title, content) => {
    setCurrentTitle(title);
    setCurrentContent(content);
  };

  return (
    <>
      <div className="w-[55%] max-md:hidden h-full p-5 pr-10 text-text5">
        <div className="flex items-center gap-4 text-text2 text-[10px]">
          <span>Solutions</span>
          <span className="scale-125 mt-1">
            <ArrowRight3SVG />
          </span>
          <span>Category 1</span>
          <span className="scale-125 mt-1">
            <ArrowRight3SVG />
          </span>
          <span className="!text-text3">Legal Bill</span>
        </div>
        <img src={Solution} alt="" className="my-16 ml-5" />
        <div className="flex flex-col gap-5 text-[14px] ml-5">
          <h4 className="text-[#AAAAAA]">{currentTitle}</h4>
          <p className="text-text2 leading-[18px] whitespace-pre-line">
            {currentContent}
          </p>
        </div>
      </div>
      <div className="w-full md:w-[45%] text-text5 md:border-l border-[#333333]">
        <div className="h-[50px] flex items-center justify-between text-[14px] max-md:text-[12px] pl-4">
          <span className="text-text2">{"[Solutions > Category 1]"}</span>
          <span className="text-text2">˙24 — ˙22</span>
        </div>
        <div className="flex flex-col">
          {Solutions.map((solution, index) => (
            <div key={index}>
              <div
                className="h-[50px] flex justify-between items-center cursor-pointer pl-4 border-t border-stroke1"
                onClick={() =>
                  handleItemClick(solution.title, solution.content)
                }
              >
                <div className="flex items-center gap-2">
                  <div
                    className={`w-3 h-3 rounded-full ${
                      currentTitle === solution.title
                        ? "bg-gradient-to-r from-[#4285F4] to-[#9B72CB]"
                        : "bg-[#AAAAAA]"
                    }`}
                  />
                  <span
                    className={`text-[14px] max-md:text-[12px] ${
                      currentTitle === solution.title
                        ? "bg-gradient-to-r from-[#4285F4] to-[#9B72CB] text-transparent bg-clip-text"
                        : "text-text2"
                    }`}
                  >
                    {solution.title}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span
                    className={`text-[14px] ${
                      currentTitle === solution.title
                        ? "bg-gradient-to-r from-[#4285F4] to-[#9B72CB] text-transparent bg-clip-text"
                        : "text-text2"
                    } mr-4 max-md:text-[10px]`}
                  >
                    {solution.cat}
                  </span>
                  <span className="text-text2 max-md:text-[12px]">
                    {solution.num}
                  </span>
                </div>
              </div>
              {/* نمایش محتوا زیر آیتم انتخاب‌شده فقط تو موبایل */}
              {currentTitle === solution.title && (
                <div className="max-md:block md:hidden p-5">
                  <div className="flex items-center gap-4 text-text2 text-[10px]">
                    <span>Solutions</span>
                    <span className="scale-125 mt-1">
                      <ArrowRight3SVG />
                    </span>
                    <span>Category 1</span>
                    <span className="scale-125 mt-1">
                      <ArrowRight3SVG />
                    </span>
                    <span className="!text-text3">Legal Bill</span>
                  </div>
                  <img src={Solution} alt="" className="my-16 ml-5" />
                  <div className="flex flex-col gap-5 text-[14px] ml-5">
                    <h4 className="text-[#AAAAAA]">{currentTitle}</h4>
                    <p className="text-text2 leading-[18px] whitespace-pre-line">
                      {currentContent}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Content;
